@if (formGroup) {
  <div class="form-container" [formGroup]="formGroup">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        @if (providers$ | async; as providers) {
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Provider </label>
            </div>
            <clickatell-form-validation [controlName]="'providerId'"
            [form]="formGroup"></clickatell-form-validation>
            <mat-select class="control-dropdown" [formControlName]="'providerId'"
              placeholder="Select Provider"
              (selectionChange)="onProviderSelected($event)">
              @for (option of providers; track option.id) {
                <mat-option [value]="option.id">
                  {{ option.name }}
                </mat-option>
              }
            </mat-select>
          </div>
        @if (instances.length > 1) {
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Instance </label>
            </div>
            <clickatell-form-validation [controlName]="'instanceId'"
            [form]="formGroup"></clickatell-form-validation>
            <mat-select class="control-dropdown" [formControlName]="'instanceId'"
              placeholder="Select Instance">
              @for (instance of instances; track instance.id) {
                <mat-option [value]="instance.id">
                  {{ instance.displayName }}
                </mat-option>
              }
            </mat-select>
          </div>
        }
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Message Endpoint </label>
          </div>
          <clickatell-form-validation [controlName]="'messageEndpoint'"
          [form]="formGroup"></clickatell-form-validation>
          <mat-select class="control-dropdown" [formControlName]="'messageEndpoint'"
            placeholder="Select Message Endpoint"
            (selectionChange)="onMessageEndpointSelected($event)">
            @for (option of messageEndpoints; track option.id) {
              <mat-option [value]="option.id">
                {{ option.name }}
              </mat-option>
            }
          </mat-select>
        </div>
        @for (param of messageEndpointParams; track param.id) {
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label">{{ param.label }}</label>
            </div>
            <clickatell-form-validation [controlName]="'msg_' + param.id" [form]="formGroup"></clickatell-form-validation>
            <input class="control-input" [formControlName]="'msg_' + param.id" [placeholder]="param.placeholder ?? param.label"/>
          </div>
        }
        @if (messageEndpointParams.length) {
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Message Parameter ID </label>
            </div>
            <clickatell-form-validation [controlName]="'messageParameterId'"
            [form]="formGroup"></clickatell-form-validation>
            @if (messageEndpointParams.length === 1) {
              <input class="control-input" [value]="messageEndpointParams[0].label ?? messageEndpointParams[0].id" disabled/>
            } @else {
              <mat-select class="control-dropdown" [formControlName]="'messageParameterId'"
                placeholder="Select Message Parameter">
                @for (param of messageEndpointParams; track param.id) {
                  <mat-option [value]="param.id">
                    {{ param.label ?? param.id }}
                  </mat-option>
                }
              </mat-select>
            }
          </div>
        }
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Media Endpoint </label>
          </div>
          <clickatell-form-validation [controlName]="'mediaEndpoint'"
          [form]="formGroup"></clickatell-form-validation>
          <mat-select class="control-dropdown" [formControlName]="'mediaEndpoint'"
            placeholder="Select Media Endpoint"
            (selectionChange)="onMediaEndpointSelected($event)">
            @for (option of mediaEndpoints; track option.id) {
              <mat-option [value]="option.id">
                {{ option.name }}
              </mat-option>
            }
          </mat-select>
        </div>
        @for (param of mediaEndpointParams; track param.id) {
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label">{{ param.label }}</label>
            </div>
            <clickatell-form-validation [controlName]="'media_' + param.id" [form]="formGroup"></clickatell-form-validation>
            <input class="control-input" [formControlName]="'media_' + param.id" [placeholder]="param.placeholder ?? param.label"/>
          </div>
        }
        @if (mediaEndpointParams.length) {
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Media Parameter ID </label>
            </div>
            <clickatell-form-validation [controlName]="'mediaParameterId'"
            [form]="formGroup"></clickatell-form-validation>
            @if (mediaEndpointParams.length === 1) {
              <input class="control-input" [value]="mediaEndpointParams[0].label ?? mediaEndpointParams[0].id" disabled/>
            } @else {
              <mat-select class="control-dropdown" [formControlName]="'mediaParameterId'"
                placeholder="Select Media Parameter">
                @for (param of mediaEndpointParams; track param.id) {
                  <mat-option [value]="param.id">
                    {{ param.label ?? param.id }}
                  </mat-option>
                }
              </mat-select>
            }
          </div>
        }
        } @else {
          <loading-icon></loading-icon>
        }
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Agent Connect Message </label>
            <label class="control-optional">Optional</label>
          </div>
          <input class="control-input" [formControlName]="'agentConnectMessage'" placeholder="Custom connecting message"/>
        </div>
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Chat Cancel Message </label>
            <label class="control-optional">Optional</label>
          </div>
          <input class="control-input" [formControlName]="'chatCancelMessage'" placeholder="Custom chat end message"/>
        </div>
      </ng-container>
    </clickatell-expansion-panel>
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Logic
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <div class="control-result">
          <div class="control-result-header">
            Next
          </div>
          <div class="control-result-container">
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Description </label>
              </div>
              <clickatell-form-validation [controlName]="'nextDescription'"
              [form]="formGroup"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="formGroup" id="next"
                [formControlName]="'nextDescription'" placeholder="Enter description"/>
            </div>
            <div class="control-div">
              <label class="control-label">
                <span class="pont-to">Point To</span>
                <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
              </label>
              @if (nodeFlowDetails) {
                <next-selector [canEditFlows]="canEdit.canEditFlows"
                  [selectorType]="'both'"
                  [flowSteps]="nodeFlowDetails.currentFlowSteps"
                  [flows]="nodeFlowDetails.flows"
                  [name]="'next'"
                  [form]="formGroup"
                  [stepId]="nodeFlowDetails.stepId">
                </next-selector>
              }
            </div>
          </div>
        </div>
        <div class="control-result">
          <div class="control-result-header">
            Error
          </div>
          <div class="control-result-container">
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Description </label>
              </div>
              <clickatell-form-validation [controlName]="'errorDescription'"
              [form]="formGroup"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="formGroup" id="error"
                [formControlName]="'errorDescription'" placeholder="Enter description"/>
            </div>
            <div class="control-div">
              <label class="control-label">
                <span class="pont-to">Point To</span>
                <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
              </label>
              @if (nodeFlowDetails) {
                <next-selector [canEditFlows]="canEdit.canEditFlows"
                  [selectorType]="'both'"
                  [flowSteps]="nodeFlowDetails.currentFlowSteps"
                  [flows]="nodeFlowDetails.flows"
                  [name]="'error'"
                  [form]="formGroup"
                  [stepId]="nodeFlowDetails.stepId">
                </next-selector>
              }
            </div>
          </div>
        </div>
      </ng-container>
    </clickatell-expansion-panel>
  </div>
}
